import { render, staticRenderFns } from "./ListMenu.vue?vue&type=template&id=345699a6&scoped=true"
import script from "./ListMenu.vue?vue&type=script&lang=ts"
export * from "./ListMenu.vue?vue&type=script&lang=ts"
import style0 from "./ListMenu.vue?vue&type=style&index=0&id=345699a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345699a6",
  null
  
)

export default component.exports